<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.WorkplaceGroupationRules.remove_exception')}}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex xs12 md5>
              <v-select
                v-model="detachUserId"
                :items="users"
                v-validate="'required'"
                :error-messages="errors.first('users')"
                name="users"
                color="indigo"
                hide-no-data
                hide-selected
                clearable
                item-text="profile.name"
                item-value="id"
                :label="$t('Pages.Users.title_singular')"
                :placeholder="$t('Common.type_to_search')"
                prepend-icon="mdi-account-group"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" type="submit">
            {{$t('Core.Fields.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['workplaceGroupationRuleId', 'value', 'users'],
  data: () => ({
    detachUserId: null,
  }),
  computed: {

  },
  created () {

  },
  methods: {
    close(){
      this.detachUser = null;
      this.$emit('close')
    },
    save(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.repositories.user.detachWorkplaceGroupationRulesUser(this.detachUserId, this.workplaceGroupationRuleId).then((response) => {
            this.$toast.success(response.data.message);
            this.$emit('refresh');
            this.close();
          });
      }});
    }
  }
}
</script>

<style lang="scss">

</style>
